enum ActionType {
    REQUEST_LOCATION_TAG_THREAT_SCORE = '[DASHBOARD/LOCATION_TAG_THREAT_SCORE] GET LOCATION TAG THREAT SCORE',
    RECEIVE_LOCATION_TAG_THREAT_SCORE = '[DASHBOARD/LOCATION_TAG_THREAT_SCORE] SET LOCATION TAG THREAT SCORE',
}

export default ActionType
